import React, { useEffect } from "react";
import PropTypes from "prop-types";
import AOS from "aos";

const Services = ({ theme }) => {
  useEffect(() => {
    AOS.refresh();

    const container = document.getElementById("dynamic-script-container");

    if (container) {
      // Entferne vorhandenes Skript, falls vorhanden
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      // Neues Skript basierend auf dem Theme hinzufügen
      const script = document.createElement("script");
      script.src =
        theme === "dark"
          ? "https://c111.travelpayouts.com/content?currency=eur&trs=383965&shmarker=601922&powered_by=false&locale=de&return=anytime&show_header=true&limit=4&primary_color=BD3C3E&results_background_color=000000&form_background_color=000000&promo_id=4478"
          : "https://c111.travelpayouts.com/content?currency=eur&trs=383965&shmarker=601922&powered_by=false&locale=de&return=anytime&show_header=true&limit=4&primary_color=BD3C3E&results_background_color=ffffff&form_background_color=ffffff&promo_id=4478";
      script.async = true;
      script.charset = "utf-8";
      container.appendChild(script);
    }
  }, [theme]); // Abhängigkeit auf `theme`, damit der Effekt bei Änderungen ausgeführt wird

  return (
    <>
      <span id="about"></span>
      <div className="dark:bg-black dark:text-white py-14 sm:min-h-[600px] sm:grid sm:place-items-center">
        <div className="container">
          <div className="pb-12">
            <h1
              data-aos="fade-up"
              className="text-3xl font-semibold text-center sm:text-4xl font-serif"
            >
Beliebte Zielorte            </h1>
          </div>

          {/* Dynamische Card mit Skript */}
          <div
            id="dynamic-script-container"
            data-aos="fade-up"
            data-aos-delay="1500"
          ></div>
        </div>
      </div>
    </>
  );
};

Services.propTypes = {
  theme: PropTypes.string.isRequired,
};

export default Services;
